export default __webpack_public_path__ + "static/media/turn.560b60f9.wav";